import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadDiagnosticsSegments
export default function RDSContent() {

    const mapTooltip = useAppSelector(state => state.mapTooltip)
    const { length, executorOrgName } = mapTooltip ?? {}

    return (
        <>
            <div className="tooltip-info-row">Протяжённость: {length} км </div>
            <div className="tooltip-info-row">Исполнитель: {executorOrgName ?? 'Не известен'} </div>
        </>
    )
}
